/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type footer_footer$ref = any;
export type Availability = "Available" | "ComingSoon" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type app_query$ref: FragmentReference;
export type app_query = {|
  +cities: $ReadOnlyArray<{|
    +slug: string,
    +name: string,
    +availability: Availability,
  |}>,
  +stores: ?$ReadOnlyArray<?{|
    +slug: string,
    +name: string,
  |}>,
  +categories: $ReadOnlyArray<{|
    +slug: ?string,
    +name: ?string,
    +availability: Availability,
  |}>,
  +footer: {|
    +$fragmentRefs: footer_footer$ref
  |},
  +$refType: app_query$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = [
  v0,
  v1,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "availability",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "app_query",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cities",
      "storageKey": null,
      "args": null,
      "concreteType": "City",
      "plural": true,
      "selections": v2
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "stores",
      "storageKey": null,
      "args": null,
      "concreteType": "Store",
      "plural": true,
      "selections": [
        v0,
        v1
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "categories",
      "storageKey": null,
      "args": null,
      "concreteType": "Category",
      "plural": true,
      "selections": v2
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "footer",
      "storageKey": null,
      "args": null,
      "concreteType": "Footer",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "footer_footer",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '38884bac91931d4d11238fa3465e164f';
module.exports = node;
